module.exports = __webpack_public_path__ + "static/img/AccountSupport_img1.6715dcd3.png";